import createPredicateIndexFinder from './_createPredicateIndexFinder.js';

// Returns the first index on an array-like that passes a truth test.
export default createPredicateIndexFinder(1);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/findIndex.js
// module id = 241
// module chunks = 106